import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { UpdateCardKycStackScreenProps, UpdateCardKycStackRoutes } from './type';
import { UpdateCardKycWebIndividualScreen } from './CardKycInfoUpdateWeb.screen';
import { UpdateCardKycNativeIndividualScreen } from './CardKycInfoUpdateNative.screen';

export const UpdateCardKycAccountIndividual: React.FC<UpdateCardKycStackScreenProps<UpdateCardKycStackRoutes.Individual>> = ({
  navigation,
  route
}) => {
  const { onLayout, data, initData, onData, func, onReturnData, refresh, onChangeView, onBackData, compareData } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <UpdateCardKycNativeIndividualScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        initData={initData}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        onBackData={onBackData}
        compareData={compareData}
      />
    );
  }

  return (
    <UpdateCardKycWebIndividualScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      onData={onData}
      initData={initData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
      onBackData={onBackData}
      compareData={compareData}
    />
  );
};
